import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('wishlist');
const GET_WISHLISTS = define('GET_WISHLISTS', true);
const ADD_WISHLIST = define('ADD_WISHLIST', true);
const REMOVE_WISHLIST = define('REMOVE_WISHLIST', true);

const initialState = {
  isLoading: true,
  wishlists: [],
  localWishlists: {}
};

const mapWishlistsToLocalState = wishlists => {
  const obj = {};
  wishlists.forEach(trip => {
    obj[trip._id] = true;
  });
  return obj;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_WISHLISTS.PENDING:
      return {
        ...state,
        wishlists: []
      };
    case GET_WISHLISTS.RESOLVED:
      return {
        ...state,
        isLoading: false,
        wishlists: action.data,
        localWishlists: mapWishlistsToLocalState(action.data)
      };
    case ADD_WISHLIST.PENDING:
      return {
        ...state,
        localWishlists: {
          ...state.localWishlists,
          [action.tripId]: true
        }
      };
    case REMOVE_WISHLIST.PENDING:
      return {
        ...state,
        localWishlists: {
          ...state.localWishlists,
          [action.tripId]: false
        }
      };
    case ADD_WISHLIST.RESOLVED:
    case REMOVE_WISHLIST.RESOLVED:
      return {
        ...state,
        wishlists: action.data,
      };
    default: return state;
  }
};

export const actions = {
  getWishlists: () => ({
    type: GET_WISHLISTS,
    promise: api.get('/users/me/wishlists')
  }),
  addWishlist: (tripId) => ({
    type: ADD_WISHLIST,
    promise: api.post(`/trips/${tripId}/wishlist`).then(() => api.get('/users/me/wishlists')),
    tripId
  }),
  removeWishlist: (tripId) => ({
    type: REMOVE_WISHLIST,
    promise: api.delete(`/trips/${tripId}/wishlist`).then(() => api.get('/users/me/wishlists')),
    tripId
  }),
};



// WEBPACK FOOTER //
// ./src/modules/wishlist.js